export default __webpack_public_path__ + "static/media/WindowsApplication.83d5bd24.png";